import React from 'react';
import { ModalBody as BootstrapModalBody } from 'reactstrap';
import PropTypes from 'prop-types';

const ModalBody = ({
  children,
  ...props
}) => (
  <BootstrapModalBody {...props}>
    {children}
  </BootstrapModalBody>
);

ModalBody.propTypes = {
  children: PropTypes.node,
};

ModalBody.defaultProps = {
  children: null,
};

export default ModalBody;
